/**
 * Styles for wf-badge component (Shadow DOM)
 */

import { css } from 'lit';

export const wfBadgeStyles = css`
  :host {
    display: inline-flex;
  }

  :host([hidden]) {
    display: none;
  }

  .wf-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: var(--wf-badge-size);
    height: var(--wf-badge-size);
    padding: var(--wf-spacing-1) var(--wf-spacing-2);
    font-size: var(--wf-font-size-xs);
    font-weight: var(--wf-font-weight-label);
    font-family: var(--wf-font-family-mono);
    text-transform: uppercase;
    flex-shrink: 0;
    line-height: 1;
  }

  .wf-badge--default {
    background-color: var(--wf-color-badge-bg);
    border: 1px solid var(--wf-color-badge-border);
    border-radius: var(--wf-radius-sm);
    color: var(--wf-color-badge-text);
  }

  .wf-badge--selected {
    background-color: var(--wf-color-primary);
    border: 1px solid var(--wf-color-primary);
    border-radius: var(--wf-radius-sm);
    color: white;
  }

  .wf-badge--button {
    background-color: transparent;
    border: none;
    border-radius: var(--wf-radius-sm);
    color: rgba(255, 255, 255, 0.65);
  }

  .wf-badge--button-secondary {
    background-color: transparent;
    border: none;
    border-radius: var(--wf-radius-sm);
    color: var(--wf-color-text-muted);
  }
`;
